import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { observer } from 'mobx-react-lite'
import { BuyButton } from 'page/catalog/buttons/BuyButton'
import { ComboButton } from 'page/catalog/buttons/ComboButton'
import { ComboTextButton } from 'page/catalog/buttons/ComboTextButton'
import { TryButton } from 'page/catalog/buttons/TryButton'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { itemPreview } from 'page/catalog/store/ItemPreviewStore'
import { ui } from 'store/home/ui/HomeUiStore'
import { opt } from 'store/opt'

export const ButtonsBase = observer(() => {
  const { small } = ui.window
  const demo = useDemo()
  const { item } = itemPreview.it
  const buy = demo.isBuyButtonVisible(item, true)
  const try_on = demo.canTry(item)
  const combine = demo.canCombine(item)

  if (small && !opt.baga) return (
    <Space gap={8} wide wrap>
      {buy && <Space flex="1" columns>
        <BuyButton item={item} />
      </Space>}
      {(try_on || combine) && <Space gap={8} flex="1" columns>
        {try_on && <Space flex="1" columns>
          <TryButton item={item} primary />
        </Space>}
        {combine ? try_on ? <ComboButton item={item} /> : <ComboTextButton item={item} /> : null}
      </Space>}
    </Space>
  )

  return (
    <Vertical gap={8} wide wrap>
      {(buy || try_on) && <Space gap={8} wide columns wrap>
        {buy && <BuyButton item={item} />}
        {try_on && <TryButton item={item} primary />}
      </Space>}
      {combine && <ComboTextButton item={item} />}
    </Vertical>
  )
})
